import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CountryInterface } from '../data';
import { CountryProvider } from '../providers/country.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetCountriesUseCase implements UseCase<Observable<Transaction<CountryInterface[]>>> {
    constructor(private countryProvider: CountryProvider) {}

    bind(): Observable<Transaction<CountryInterface[]>> {
        return this.countryProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (countries) => Transaction.success(cloneDeep(countries)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
